
import { ACTIONS } from './constants'

// Actions
export const setFilters = (filters) => ({
  type: ACTIONS.SET_FILTERS,
  filters
})
